<template>
    <div class="chat-emojis-dropdown" v-bind:class="{ 'dropdown-open': dropdownOpen === true }">
        <button type="button" v-on:click="chatToggleDropdown" class="button-toggle" aria-label="Insert emoji" aria-haspopup="true" :aria-expanded="dropdownOpen ? 'true' : 'false'">
            <IconEmojisGradient />
            <span>Emojis</span>
        </button>
        <div class="dropdown-window">
            <div class="window-inner">
                <div class="inner-list">

                    <button v-for="(emoji, index) in dropdownEmojis" v-on:click="chatEmojiButton(emoji)">{{emoji}}</button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconEmojisGradient from '@/components/icons/IconEmojisGradient';

    export default {
        name: 'ChatEmojisDropdown',
        components: {
            IconEmojisGradient
        },
        data() {
            return {
                dropdownOpen: false,
                dropdownEmojis: [
                    '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍',
                    '🤩', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔',
                    '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴',
                    '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓',
                    '🧐', '😕', '😟', '🙁', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢',
                    '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱', '😤', '😡', '😠', '🤬', '😈', '👿',
                    '💀'
                ]
            }
        },
        methods: {
            chatToggleDropdown() {
                this.dropdownOpen = !this.dropdownOpen;
            },
            chatEmojiButton(emoji) {
                this.chatToggleDropdown();
                this.$parent.chatAddEmoji(emoji);
            }
        },
        created() {
            let self = this;
            document.addEventListener('click', function(event) {
                if(!self.$el.contains(event.target) && self.dropdownOpen == true) {
                    self.chatToggleDropdown();
                }
            });
        }
    }
</script>

<style scoped>
    .chat-emojis-dropdown {
        position: relative;
    }

    .chat-emojis-dropdown button.button-toggle {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: rgba(255, 255, 255, 0.88);
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 10px 14px;
        min-height: 44px;
        cursor: pointer;
        transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    .chat-emojis-dropdown button.button-toggle:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.16);
        color: #ffffff;
    }

    .chat-emojis-dropdown button.button-toggle:focus-visible {
        outline: 2px solid rgba(0, 255, 194, 0.45);
        outline-offset: 2px;
    }

    .chat-emojis-dropdown button.button-toggle svg {
        flex-shrink: 0;
    }

    .chat-emojis-dropdown .dropdown-window {
        width: min(325px, calc(100vw - 32px));
        height: 0;
        position: absolute;
        display: flex;
        align-items: flex-end;
        bottom: calc(100% + 8px);
        right: 0;
        left: auto;
        padding: 0;
        transition: height 0.2s ease;
        overflow: hidden;
        z-index: 20;
    }

    @media only screen and (max-width: 360px) {
        .chat-emojis-dropdown .dropdown-window {
            width: calc(100vw - 24px);
            right: 0;
        }
    }

    .chat-emojis-dropdown.dropdown-open .dropdown-window {
       height: 140px;
       padding: 15px 15px 0 15px;
    }

    .chat-emojis-dropdown .window-inner {
        width: 100%;
        max-width: 295px;
        height: 110px;
        position: relative;
        margin-bottom: 14px;
        margin-left: auto;
        padding: 13px;
        border-radius: 15px;

        background: var(--bg-primary);
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
    }

    .chat-emojis-dropdown .window-inner::before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        bottom: -14px;
        right: 60px;
        border-left: 15px solid transparent;
        border-top: 14px solid var(--bg-primary);
    }

    .chat-emojis-dropdown .inner-list {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        overflow-y: scroll;
    }

    .chat-emojis-dropdown .inner-list::-webkit-scrollbar-track {
        background-color: transparent;
    }

    .chat-emojis-dropdown .inner-list::-webkit-scrollbar-thumb {
        background-color: transparent;
    }

    .chat-emojis-dropdown .inner-list::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    .chat-emojis-dropdown .inner-list button {
        width: 9.09%;
        height: 26px;
        font-size: 18px;
    }
</style>
